import { useCallback, useMemo } from 'react'
import Cache from '@fs/zion-cache'

export default function useCache(key, storeName = 'ftte', type = 'session') {
  const cache = useMemo(() => new Cache({ storeName, type }), [storeName, type])

  const getCachedValue = useCallback(() => cache.getItem(key), [cache, key])

  const setCachedValue = useCallback((newValue) => cache.setItem(key, newValue), [cache, key])

  return [getCachedValue, setCachedValue]
}

export function getCachedValuePromise(key, storeName = 'ftte', type = 'session') {
  const cache = new Cache({ storeName, type })
  return cache.getItem(key)
}
